import React from "react";
import "../../css/document/documentfilter.css";

export default function DocumentFilters({ filters, setFilters }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="document-filters">
      {/* Document Type */}
      <select
        className="filter-select"
        name="document_type"
        value={filters.document_type}
        onChange={handleChange}
      >
        <option value="all">All Types</option>
        <option value="kyc">KYC</option>
        <option value="property_papers">Property Papers</option>
        <option value="agreement">Agreement</option>
        <option value="offer_letter">Offer Letter</option>
        <option value="invoice">Invoice</option>
        <option value="other">Other</option>
      </select>

      {/* Status */}
      <select
        className="filter-select"
        name="status"
        value={filters.status}
        onChange={handleChange}
      >
        <option value="all">All Status</option>
        <option value="pending">Pending</option>
        <option value="verified">Verified</option>
        <option value="rejected">Rejected</option>
      </select>
    </div>
  );
}
